const events = {
    WS_CONNECTION: 'WS_CONNECTION',
    TEMPORARY_ORDER_CREATED: 'TEMPORARY_ORDER_CREATED',
    ORDER_CREATED: 'ORDER_CREATED',
    NOTIFICATION_CREATED: 'NOTIFICATION_CREATED',
    PRODUCT_UPDATED: 'PRODUCT_UPDATED',
    ORDER_STATUS_UPDATED: 'ORDER_STATUS_UPDATED'
}

export default events;